export const categories = [
  { slug: "all", name: "全部", icon: "ri-grid-line" },
  { slug: "romance", name: "恋爱", icon: "ri-heart-line" },
  { slug: "fantasy", name: "奇幻", icon: "ri-magic-line" },
  { slug: "action", name: "动作", icon: "ri-sword-line" },
  { slug: "suspense", name: "悬疑", icon: "ri-search-eye-line" },
  { slug: "comedy", name: "搞笑", icon: "ri-emotion-laugh-line" },
  { slug: "horror", name: "恐怖", icon: "ri-ghost-line" },
  { slug: "school", name: "校园", icon: "ri-building-2-line" },
  { slug: "urban", name: "都市", icon: "ri-building-line" },
];

export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  cover: string;
  description: string;
  fullDescription: string;
  rating: number;
  views: number;
  totalChapters: number;
  chapters: ComicChapter[];
  tags: string[];
  status: "连载中" | "已完结";
  updatedAt: string;
}

export const comics: Comic[] = [
  {
    id: "comic-001",
    title: "秘密花园",
    author: "金秀雅",
    category: "romance",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20comic%20cover%20art%20style%2C%20beautiful%20couple%20in%20flower%20garden%2C%20soft%20warm%20lighting%2C%20romantic%20atmosphere%2C%20delicate%20linework%2C%20pastel%20color%20palette%2C%20Korean%20webtoon%20illustration%20with%20clean%20simple%20background%20and%20expressive%20characters&width=600&height=800&seq=hanman-cover-001&orientation=portrait",
    description: "一段跨越时空的浪漫爱情故事，在繁花似锦的秘密花园中悄然绽放。两个来自不同世界的灵魂，因命运的安排相遇相知。",
    fullDescription: "在首尔繁华都市的一隅，隐藏着一座被世人遗忘的秘密花园。大学生林智恩偶然闯入这片净土，遇到了守护花园的神秘男子韩在旭。两人在繁花似锦的庭院中，展开了一段跨越时空的浪漫爱情故事。然而，花园深处隐藏的秘密，正在悄然改变他们的命运……",
    rating: 9.2,
    views: 1528000,
    totalChapters: 86,
    chapters: [
      { id: "ch-001-1", title: "第1话 相遇", number: 1, updatedAt: "2026-07-20" },
      { id: "ch-001-2", title: "第2话 秘密", number: 2, updatedAt: "2026-07-22" },
      { id: "ch-001-3", title: "第3话 绽放", number: 3, updatedAt: "2026-07-25" },
      { id: "ch-001-4", title: "第4话 月光", number: 4, updatedAt: "2026-07-28" },
      { id: "ch-001-5", title: "第5话 约定", number: 5, updatedAt: "2026-08-01" },
    ],
    tags: ["恋爱", "奇幻", "治愈", "唯美"],
    status: "连载中",
    updatedAt: "2026-08-01",
  },
  {
    id: "comic-002",
    title: "深渊之眼",
    author: "朴振宇",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20dark%20fantasy%20comic%20cover%2C%20mysterious%20eye%20in%20the%20abyss%2C%20dramatic%20lighting%20with%20purple%20and%20black%20tones%2C%20epic%20fantasy%20illustration%20style%2C%20Korean%20webtoon%20art%20with%20detailed%20linework%20on%20simple%20dark%20background&width=600&height=800&seq=hanman-cover-002&orientation=portrait",
    description: "在深渊的尽头，有一只凝视着世界的眼睛。背负着神秘力量的主角踏上冒险之旅，揭开古老传说背后的惊天秘密。",
    fullDescription: "少年李玄宇拥有与生俱来的特殊能力——他能够看到常人无法察觉的「深渊之眼」。这只神秘的眼睛指引着他前往一个充满魔法与怪物的异世界。在那里，他必须与伙伴们一起，对抗来自深渊的黑暗势力，揭开远古神话背后的真相。一场关于勇气、友情与牺牲的史诗冒险，就此展开。",
    rating: 9.5,
    views: 2310000,
    totalChapters: 128,
    chapters: [
      { id: "ch-002-1", title: "第1话 觉醒", number: 1, updatedAt: "2026-06-15" },
      { id: "ch-002-2", title: "第2话 异界", number: 2, updatedAt: "2026-06-18" },
      { id: "ch-002-3", title: "第3话 试炼", number: 3, updatedAt: "2026-06-22" },
    ],
    tags: ["奇幻", "冒险", "热血", "战斗"],
    status: "连载中",
    updatedAt: "2026-08-03",
  },
  {
    id: "comic-003",
    title: "恋与星辰",
    author: "崔敏静",
    category: "romance",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20comic%20cover%2C%20couple%20under%20starry%20night%20sky%2C%20romantic%20celestial%20theme%2C%20warm%20golden%20and%20navy%20color%20palette%2C%20Korean%20webtoon%20art%20style%20with%20soft%20glowing%20stars%20and%20dreamy%20atmosphere%20on%20simple%20background&width=600&height=800&seq=hanman-cover-003&orientation=portrait",
    description: "天文系学霸与摇滚乐队主唱的奇妙邂逅。在繁星点点的夜空下，两颗截然不同的心逐渐靠近。",
    fullDescription: "首尔大学天文系的学霸金智勋，人生中只有学习和星星。直到那天，他在校园音乐节上遇到了摇滚乐队主唱朴慧琳。她的歌声像流星一样划破他平静的生活。一个是理性冷静的理科男，一个是热情奔放的音乐少女——两个完全不同世界的人，在星辰的见证下，谱写出一段甜蜜又心动的校园恋曲。",
    rating: 9.0,
    views: 1890000,
    totalChapters: 64,
    chapters: [
      { id: "ch-003-1", title: "第1话 流星", number: 1, updatedAt: "2026-07-10" },
      { id: "ch-003-2", title: "第2话 音符", number: 2, updatedAt: "2026-07-13" },
    ],
    tags: ["恋爱", "校园", "音乐", "治愈"],
    status: "连载中",
    updatedAt: "2026-08-02",
  },
  {
    id: "comic-004",
    title: "暗夜追踪者",
    author: "郑道贤",
    category: "action",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20comic%20cover%2C%20mysterious%20detective%20in%20dark%20alley%2C%20noir%20atmosphere%20with%20dramatic%20shadows%2C%20Korean%20webtoon%20style%20illustration%2C%20intense%20city%20night%20scene%20with%20clean%20composition%20and%20striking%20contrast&width=600&height=800&seq=hanman-cover-004&orientation=portrait",
    description: "白天是普通上班族，夜晚化身正义追踪者。在首尔暗夜的掩护下，追踪连环罪犯的孤胆英雄传奇。",
    fullDescription: "姜赫是一名普通的保险公司职员，但每到夜晚，他便化身为追捕罪犯的「暗夜追踪者」。凭借敏锐的洞察力和过人的格斗技巧，他在首尔的黑夜中追踪那些法律的漏网之鱼。然而，当他卷入一起涉及高层的连环命案时，他发现真相远比想象中更加黑暗……",
    rating: 9.3,
    views: 1750000,
    totalChapters: 95,
    chapters: [
      { id: "ch-004-1", title: "第1话 双重生活", number: 1, updatedAt: "2026-05-20" },
      { id: "ch-004-2", title: "第2话 第一滴血", number: 2, updatedAt: "2026-05-23" },
    ],
    tags: ["动作", "悬疑", "都市", "犯罪"],
    status: "连载中",
    updatedAt: "2026-08-01",
  },
  {
    id: "comic-005",
    title: "校园罗曼史",
    author: "尹雪花",
    category: "school",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20romance%20comic%20cover%2C%20high%20school%20couple%20in%20cherry%20blossom%20spring%2C%20youthful%20fresh%20vibrant%20colors%2C%20Korean%20webtoon%20illustration%20style%20with%20clean%20simple%20school%20background%20and%20warm%20spring%20lighting&width=600&height=800&seq=hanman-cover-005&orientation=portrait",
    description: "高中校园里的青涩初恋，学霸班长与转学生的甜蜜日常。青春最美好的样子，都在这里。",
    fullDescription: "仁川高中三年级的班长韩素媛，是全校公认的模范生。新学期开始，从首尔转学来的李灿赫打破了她的平静生活。他不羁的性格和温暖的笑容，让素媛第一次体会到了心跳加速的感觉。在樱花盛开的校园里，一段纯真美好的青春恋曲正在奏响。",
    rating: 8.9,
    views: 1420000,
    totalChapters: 72,
    chapters: [
      { id: "ch-005-1", title: "第1话 转学生", number: 1, updatedAt: "2026-06-01" },
      { id: "ch-005-2", title: "第2话 同桌", number: 2, updatedAt: "2026-06-04" },
    ],
    tags: ["校园", "恋爱", "青春", "日常"],
    status: "连载中",
    updatedAt: "2026-07-30",
  },
  {
    id: "comic-006",
    title: "奇幻大陆：龙之传说",
    author: "宋泰元",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20adventure%20comic%20cover%2C%20dragon%20and%20warrior%20in%20epic%20landscape%2C%20vibrant%20magical%20colors%2C%20Korean%20webtoon%20art%20style%20with%20detailed%20fantasy%20elements%20on%20simple%20sky%20background&width=600&height=800&seq=hanman-cover-006&orientation=portrait",
    description: "龙骑士的传奇冒险，在魔法与剑的世界里，少年成长为拯救大陆的英雄。",
    fullDescription: "在遥远的艾泽拉大陆，龙族与人类曾签订和平契约。然而千年之后，黑暗势力打破了平衡。少年艾伦意外获得了与最后一只黄金巨龙沟通的能力，踏上成为龙骑士的征途。他必须穿越五大王国，集齐失落的神器，在龙之传说的指引下，拯救濒临毁灭的大陆。",
    rating: 9.6,
    views: 2890000,
    totalChapters: 150,
    chapters: [
      { id: "ch-006-1", title: "第1话 预言", number: 1, updatedAt: "2026-04-10" },
      { id: "ch-006-2", title: "第2话 龙鸣", number: 2, updatedAt: "2026-04-13" },
    ],
    tags: ["奇幻", "冒险", "热血", "魔法"],
    status: "已完结",
    updatedAt: "2026-07-15",
  },
  {
    id: "comic-007",
    title: "命运之轮",
    author: "张慧珍",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20mystery%20comic%20cover%2C%20mysterious%20fortune%20wheel%20with%20celestial%20elements%2C%20golden%20and%20deep%20blue%20color%20palette%2C%20Korean%20webtoon%20illustration%20with%20magical%20atmosphere%20and%20clean%20simple%20background&width=600&height=800&seq=hanman-cover-007&orientation=portrait",
    description: "能预知未来的少女，却无法改变自己的命运。在命运之轮的转动中，她能否突破宿命的束缚？",
    fullDescription: "高中女生姜智雅从小拥有预知未来的能力，但她看到的未来片段总是以悲剧收场。直到她遇到了同样拥有特殊能力的转学生金贤宇——一个能改变预知结果的人。两人联手试图改写命运，却发现更大的命运之轮正在转动，他们的每一次选择都在影响整个世界的走向。",
    rating: 9.1,
    views: 1620000,
    totalChapters: 78,
    chapters: [
      { id: "ch-007-1", title: "第1话 预知", number: 1, updatedAt: "2026-05-05" },
      { id: "ch-007-2", title: "第2话 改变", number: 2, updatedAt: "2026-05-08" },
    ],
    tags: ["奇幻", "悬疑", "校园", "命运"],
    status: "连载中",
    updatedAt: "2026-08-03",
  },
  {
    id: "comic-008",
    title: "甜蜜陷阱",
    author: "李秀晶",
    category: "romance",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romantic%20comedy%20comic%20cover%2C%20sweet%20couple%20with%20desserts%20in%20cafe%2C%20warm%20pink%20and%20cream%20color%20palette%2C%20Korean%20webtoon%20style%20with%20cute%20charming%20art%20on%20simple%20cozy%20background&width=600&height=800&seq=hanman-cover-008&orientation=portrait",
    description: "甜品师与美食评论家的爆笑恋爱攻防战！当挑剔的味蕾遇上甜蜜的心动，谁能先落入陷阱？",
    fullDescription: "首尔最年轻的米其林甜品师郑多恩，遇到了她的最大挑战——刻薄又帅气的美食评论家朴正宇。他给了她的甜品店史上最低评分，她发誓要让他收回评价。然而在一次次的美食交锋中，两人之间却产生了微妙的情愫。这到底是甜蜜的陷阱，还是命运的安排？",
    rating: 8.7,
    views: 1350000,
    totalChapters: 56,
    chapters: [
      { id: "ch-008-1", title: "第1话 差评", number: 1, updatedAt: "2026-07-01" },
      { id: "ch-008-2", title: "第2话 对决", number: 2, updatedAt: "2026-07-04" },
    ],
    tags: ["恋爱", "美食", "喜剧", "都市"],
    status: "连载中",
    updatedAt: "2026-07-28",
  },
  {
    id: "comic-009",
    title: "武林至尊",
    author: "姜泰浩",
    category: "action",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20action%20comic%20cover%2C%20warrior%20with%20sword%20in%20ancient%20Korean%20setting%2C%20dramatic%20dynamic%20composition%2C%20Korean%20webtoon%20art%20style%20with%20powerful%20martial%20arts%20scene%20on%20simple%20mountain%20background&width=600&height=800&seq=hanman-cover-009&orientation=portrait",
    description: "落魄门派的传人，如何一步步登上武林巅峰？热血战斗与江湖恩怨交织的武侠史诗。",
    fullDescription: "武林第一大派「天剑门」在一夜之间被灭门，唯一的幸存者——年幼的弟子李风云背负血海深仇，在神秘老人的指导下苦练武艺。十五年后，他重出江湖，却发现灭门惨案背后隐藏着整个武林的惊天阴谋。一场关于复仇、正义与武道的传奇，即将拉开序幕。",
    rating: 9.4,
    views: 2100000,
    totalChapters: 110,
    chapters: [
      { id: "ch-009-1", title: "第1话 灭门", number: 1, updatedAt: "2026-03-15" },
      { id: "ch-009-2", title: "第2话 拜师", number: 2, updatedAt: "2026-03-18" },
    ],
    tags: ["动作", "武侠", "热血", "复仇"],
    status: "连载中",
    updatedAt: "2026-08-04",
  },
  {
    id: "comic-010",
    title: "星空下的约定",
    author: "安美妍",
    category: "school",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20youth%20romance%20comic%20cover%2C%20students%20on%20rooftop%20under%20starry%20sky%2C%20warm%20nostalgic%20color%20palette%2C%20Korean%20webtoon%20art%20style%20with%20gentle%20evening%20atmosphere%20and%20simple%20school%20background&width=600&height=800&seq=hanman-cover-010&orientation=portrait",
    description: "天文社的五个少年，一个关于梦想、友情和青春的约定。毕业前的最后一年，他们能否实现各自的愿望？",
    fullDescription: "在首尔一所普通高中的天文社里，五个性格迥异的少年因为对星空的共同热爱走到了一起。他们约定在毕业前一起看到最美的流星雨。然而，升学压力、家庭问题和各自的秘密，让这个约定变得岌岌可危。在星空下，他们将学会成长、告别与珍惜。",
    rating: 8.8,
    views: 1280000,
    totalChapters: 48,
    chapters: [
      { id: "ch-010-1", title: "第1话 天文社", number: 1, updatedAt: "2026-06-20" },
      { id: "ch-010-2", title: "第2话 新成员", number: 2, updatedAt: "2026-06-23" },
    ],
    tags: ["校园", "青春", "友情", "治愈"],
    status: "连载中",
    updatedAt: "2026-07-25",
  },
  {
    id: "comic-011",
    title: "恶魔契约",
    author: "权志勋",
    category: "horror",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20supernatural%20comic%20cover%2C%20mysterious%20contract%20with%20demonic%20elements%2C%20dark%20red%20and%20black%20color%20palette%2C%20Korean%20webtoon%20art%20style%20with%20eerie%20atmosphere%20and%20simple%20dark%20background&width=600&height=800&seq=hanman-cover-011&orientation=portrait",
    description: "为了拯救妹妹，他与恶魔签订了契约。每一次交易都要付出灵魂的代价——他能坚持到最后吗？",
    fullDescription: "大学生赵贤宇的妹妹患上了一种罕见的绝症。绝望之际，一个自称「冥界使者」的神秘人出现在他面前，提出了一份恶魔契约——用他帮助抓捕100个恶人的灵魂，来换取妹妹的生命。贤宇被迫踏上了这条不归路，却发现每一个「恶人」背后，都藏着更加复杂的真相。",
    rating: 9.3,
    views: 1980000,
    totalChapters: 88,
    chapters: [
      { id: "ch-011-1", title: "第1话 代价", number: 1, updatedAt: "2026-04-25" },
      { id: "ch-011-2", title: "第2话 第一次任务", number: 2, updatedAt: "2026-04-28" },
    ],
    tags: ["恐怖", "悬疑", "超自然", "暗黑"],
    status: "连载中",
    updatedAt: "2026-08-02",
  },
  {
    id: "comic-012",
    title: "时光倒流",
    author: "白智恩",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20time%20travel%20romance%20comic%20cover%2C%20vintage%20clock%20with%20magical%20effects%2C%20warm%20sepia%20and%20gold%20color%20palette%2C%20Korean%20webtoon%20illustration%20style%20with%20mysterious%20nostalgic%20atmosphere%20on%20simple%20background&width=600&height=800&seq=hanman-cover-012&orientation=portrait",
    description: "一枚古老的怀表，让她回到了十年前。有机会重来一次的人生，她能否弥补所有遗憾？",
    fullDescription: "三十岁的职场女性徐恩雅，在整理已故祖母遗物时，发现了一枚刻有奇异符文的古老怀表。当她拨动表针的那一刻，时光倒流——她回到了二十岁，回到了那个改变了人生轨迹的关键时刻。面对熟悉又陌生的一切，恩雅决定这一次，绝不再让遗憾重演。",
    rating: 9.0,
    views: 1680000,
    totalChapters: 70,
    chapters: [
      { id: "ch-012-1", title: "第1话 怀表", number: 1, updatedAt: "2026-05-10" },
      { id: "ch-012-2", title: "第2话 十年前", number: 2, updatedAt: "2026-05-13" },
    ],
    tags: ["奇幻", "恋爱", "治愈", "时间"],
    status: "连载中",
    updatedAt: "2026-08-01",
  },
];

export const faqs = [
  {
    question: "韩漫漫画网的漫画是否完全免费？",
    answer: "是的！韩漫漫画网承诺所有韩国漫画永久免费在线阅读，您无需支付任何费用即可畅享海量正版韩漫资源。我们通过广告收入来维持网站运营，让每一位漫画爱好者都能零门槛享受阅读乐趣。",
  },
  {
    question: "网站上的漫画多久更新一次？",
    answer: "我们与韩国多家漫画平台保持紧密合作，热门连载漫画通常每周更新1-2话。部分高人气作品甚至可以实现与韩国同步更新，确保您能第一时间看到最新内容。",
  },
  {
    question: "需要注册账号才能阅读吗？",
    answer: "不需要！韩漫漫画网支持无需注册即可免费在线阅读韩漫。当然，注册账号后您可以享受收藏漫画、阅读记录同步、评论互动等更多便捷功能。",
  },
  {
    question: "网站支持手机阅读吗？",
    answer: "完全支持！我们的网站采用响应式设计，无论您使用电脑、平板还是手机，都能获得流畅舒适的韩漫阅读体验。在手机上阅读时，排版会自动适配屏幕，让您随时随地畅享韩漫。",
  },
  {
    question: "漫画画质如何？支持高清阅读吗？",
    answer: "我们提供的韩国漫画均为高清画质，支持缩放查看细节。每一话都经过精心优化，确保在保证加载速度的同时，为您呈现最清晰的画面效果。",
  },
];

export const testimonials = [
  {
    name: "漫画迷小王",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20young%20male%20character%20portrait%2C%20friendly%20smile%2C%20simple%20warm%20background%2C%20clean%20illustration&width=100&height=100&seq=hanman-avatar-01&orientation=squarish",
    comment: "这个网站真的太好了！韩漫资源超级全，更新也快，画质清晰。我已经推荐给好多朋友了！",
    rating: 5,
  },
  {
    name: "追漫达人小美",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20young%20female%20character%20portrait%2C%20bright%20smile%2C%20simple%20warm%20background%2C%20clean%20illustration&width=100&height=100&seq=hanman-avatar-02&orientation=squarish",
    comment: "终于找到一个不用注册就能免费看韩漫的网站了！分类很详细，找漫画特别方便，每天都要来刷更新。",
    rating: 5,
  },
  {
    name: "资深韩漫读者",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20male%20character%20portrait%20with%20glasses%2C%20gentle%20expression%2C%20simple%20warm%20background%2C%20clean%20illustration&width=100&height=100&seq=hanman-avatar-03&orientation=squarish",
    comment: "看了五六年韩漫了，韩漫漫画网是我用过体验最好的网站。无遮版本、全彩高清，强烈推荐！",
    rating: 5,
  },
];